import carWork from "@/components/work/carWork";
import carWorks from "@/components/work/carWorks";
import areaWorks from "@/components/work/areaWorks";
import personUnqualified from "@/components/work/personUnqualified";
import lineWorks from "@/components/work/lineWorks";
import personWork from "@/components/work/personWork";
import carNoWork from "@/components/work/carNoWork";
import PersonQualified from "@/components/work/PersonQualified";
import checkin from "../../node_modules/common/src/components/checkin/person";
import checkinDriver from "../../node_modules/common/src/components/checkin/driver";
var data = [
  {
    path: "/carWork",
    component: carWork
  },
  {
    path: "/carWorks",
    component: carWorks
  },
  {
    path: "/areaWorks",
    component: areaWorks
  },
  {
    path: "/lineWorks",
    component: lineWorks
  },
  {
    path: "/PersonQualified",
    component: PersonQualified
  },
  {
    path: "/personUnqualified",
    component: personUnqualified
  },
  {
    path: "/carNoWork",
    component: carNoWork
  },
  {
    path: "/personWork",
    component: personWork
  },
  {
    path: "/checkin",
    component: checkin
  },
  {
    path: "/checkinDriver",
    component: checkinDriver
  },
];
export default data;


// WEBPACK FOOTER //
// ./src/router/work.js